import { VariantProps, cva } from 'class-variance-authority';

export const tag = cva(
  ['px-1', 'font-normal', 'rounded', 'inline-flex', 'items-center'],
  {
    variants: {
      intent: {
        positive: ['text-green-600', 'bg-green-100'],
        negative: ['text-red-700', 'bg-red-100'],
        warning: ['text-yellow-800', 'bg-yellow-100'],
        neutral: ['text-primary-700', 'bg-primary-100'],
      },
      size: {
        sm: ['text-[0.75rem]', 'leading-4'],
        md: ['text-[0.875rem]', 'leading-5'],
        lg: ['text-[1rem]', 'leading-6'],
      },
    },
    compoundVariants: [],
    defaultVariants: {
      intent: 'neutral',
      size: 'md',
    },
  }
);

export type StyleProps = Partial<VariantProps<typeof tag>>;
